export default __webpack_public_path__ + "static/tag-do-3-dark-dc4dcfeaa821cb0578b38c62851926d7fe432700442d7783d6074612f274ee3a.png";